const h = (c) => {
  let r = {};
  return c.data && c.data.forEach((a) => {
    var i, e;
    let o = a.path;
    if (a.message.includes("is missing the required field") && ((e = (i = a.original) == null ? void 0 : i.params) != null && e.missingProperty) && (o += "." + a.original.params.missingProperty), !a.message.includes("anyOf") && !a.message.includes("must be a null")) {
      let t = [a.message], s = get(r, o + ".$errors");
      s ? set(r, o + ".$errors", [...t, ...s]) : set(r, o + ".$errors", t);
    }
  }), typeof r.$ < "u" ? r.$ : {};
};
class u {
  constructor(r, a, o = null, i = "_id") {
    this.state = {
      snackbarStore: o,
      createUpdateDialog: !1,
      deleteDialog: !1,
      fetchLoading: !1,
      itemLoaded: !1,
      writeLoading: !1,
      deleteLoading: !1,
      currentItem: {},
      deleteItem: {},
      selectedItems: null,
      items: [],
      validationErrors: {}
    }, this.actions = {
      resetValidation() {
        this.validationErrors = {};
      },
      sleep(e) {
        return new Promise((t) => setTimeout(t, e));
      },
      toggleCreateUpdateDialog(e = {}) {
        e !== !1 && (this.currentItem = e), this.createUpdateDialog || this.resetValidation(), this.createUpdateDialog = !this.createUpdateDialog;
      },
      toggleDeleteDialog(e = {}, t = !0) {
        e !== !1 && (this.deleteItem = e), this.deleteDialog || this.resetValidation(), this.deleteDialog = !this.deleteDialog;
      },
      setParameter(e, t, s) {
        e[t] = s;
      },
      setCurrentItem(e) {
        this.currentItem = e;
      },
      addItems(e) {
        this.items.push(...e);
      },
      setItems(e) {
        this.items = e;
      },
      setSelectedItems(e) {
        this.selectedItems = e;
      },
      removeItem(e) {
        let t = this.items.findIndex((s) => e[i] === s[i]);
        this.items.splice(t, 1), this.currentItem && e[i] === this.currentItem[i] && (this.currentItem.id = {});
      },
      async fetchItems(e = {}) {
        this.fetchLoading = !0;
        try {
          const t = await a.service(r).find({
            query: e
          });
          this.items = t.data;
        } catch (t) {
          return this.setSnackbarMessage("Fetch items failed.", "error"), console.error(t), this.fetchLoading = !1, !1;
        }
        return this.fetchLoading = !1, this.items;
      },
      async bulkCreate(e) {
        this.writeLoading = !0;
        try {
          const t = await a.service(r).create(e);
          this.items.push(...t);
        } catch (t) {
          return this.setSnackbarMessage("Bulk create items failed.", "error"), console.error(t), this.writeLoading = !1, this.validationErrors = h(t), !1;
        }
        this.writeLoading = !1;
      },
      async bulkDelete(e) {
        const t = `${r}bulk_delete/`;
        this.deleteLoading = !0;
        try {
          await a.service(t).create(e), e.forEach((s) => {
            this.removeItem(s);
          });
        } catch (s) {
          return this.setSnackbarMessage("Failed to delete items.", "error"), console.error(s), this.deleteLoading = !1, !1;
        }
        this.deleteLoading = !1;
      },
      async update(e = null) {
        this.writeLoading = !0;
        const t = e || this.currentItem;
        let s;
        try {
          s = await a.service(r).patch(t[i], t);
          const n = this.items.map((l) => l[i]).indexOf(s[i]);
          this.items[n] = s;
        } catch (n) {
          return this.setSnackbarMessage("Update item failed.", "error"), console.error(n), this.writeLoading = !1, this.validationErrors = h(n), !1;
        }
        return this.writeLoading = !1, s;
      },
      async create(e = null, t = []) {
        this.writeLoading = !0;
        const s = e || this.currentItem;
        let n;
        try {
          n = await a.service(r).create(s);
          const l = structuredClone(n);
          for (const d of t)
            delete l[d];
          this.items.push(l);
        } catch (l) {
          return this.setSnackbarMessage("Create item failed.", "error"), console.error(l), this.writeLoading = !1, this.validationErrors = h(l), !1;
        }
        return this.writeLoading = !1, n;
      },
      async delete(e = null) {
        this.deleteLoading = !0;
        const t = e || this.deleteItem;
        let s;
        try {
          await a.service(r).remove(t[i]), s = t, this.removeItem(t);
        } catch (n) {
          const l = n.message || "Delete item failed.";
          return this.setSnackbarMessage(l, "error"), console.error(n), this.deleteLoading = !1, this.validationErrors = h(n), !1;
        }
        return this.deleteItem = null, this.deleteLoading = !1, s;
      },
      async fetchItem(e) {
        this.fetchLoading = !0;
        const t = await a.service(r).get(e);
        return this.currentItem = t, this.fetchLoading = !1, this.itemLoaded = !0, t;
      },
      setSnackbarMessage(e, t) {
        this.snackbarStore && this.snackbarStore.setMessage(e, t);
      }
    }, this.getters = {
      getItem: (e) => (t) => e.items.find((s) => s[i] === t)
    };
  }
}
export {
  u as default
};
